import React, { useState } from 'react';

const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    marketplace: '',
  });
  const [focusedField, setFocusedField] = useState(null);
  const [submitStatus, setSubmitStatus] = useState('idle');
  const [submitError, setSubmitError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      let digits = value.replace(/\D/g, '');
      if (digits.length === 0) {
        setFormData(prev => ({ ...prev, phone: '' }));
      } else {
        if (digits[0] === '7' || digits[0] === '8') digits = digits.slice(1);
        digits = digits.slice(0, 10);
        let formatted = '+7';
        if (digits.length > 0) formatted += ' (' + digits.slice(0, 3);
        if (digits.length >= 3) formatted += ') ';
        if (digits.length > 3) formatted += digits.slice(3, 6);
        if (digits.length > 6) formatted += '-' + digits.slice(6, 8);
        if (digits.length > 8) formatted += '-' + digits.slice(8, 10);
        setFormData(prev => ({ ...prev, phone: formatted }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitStatus === 'loading') return;
    if (!formData.name.trim() || !formData.phone.trim()) {
      setSubmitError('Заполните имя и телефон');
      return;
    }

    setSubmitStatus('loading');
    setSubmitError('');

    try {
      const response = await fetch('https://leads.deshiki.ru/api/leads', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': '1seller-leads-2026-secure-key',
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone.replace(/\D/g, ''),
          marketplace: formData.marketplace || undefined,
          source: window.location.hostname,
          pageUrl: window.location.pathname + '#contact',
          device: /Android|iPhone|iPad/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
          screenSize: `${window.screen.width}x${window.screen.height}`,
        }),
      });

      if (!response.ok) throw new Error('HTTP ' + response.status);

      setSubmitStatus('success');
      setFormData({ name: '', phone: '', marketplace: '' });
      setTimeout(() => setSubmitStatus('idle'), 3000);
    } catch (error) {
      setSubmitStatus('error');
      setSubmitError('Ошибка отправки. Попробуйте позже.');
      console.error('Contact submit error:', error);
      setTimeout(() => { setSubmitStatus('idle'); setSubmitError(''); }, 5000);
    }
  };

  const benefits = [
    {
      icon: '/images/icons/search.webp',
      title: 'Анализ ниши за 24 часа',
      desc: 'Бесплатно проанализируем вашу нишу и конкурентов на всех площадках',
    },
    {
      icon: '/images/icons/chart.webp',
      title: 'Персональная стратегия',
      desc: 'Составим пошаговый план запуска и продвижения под ваш бюджет',
    },
    {
      icon: '/images/icons/trophy.webp',
      title: '6 000+ успешных запусков',
      desc: 'Проверенная методология, отработанная на тысячах магазинов',
    },
    {
      icon: '/images/icons/shield.webp',
      title: 'Без скрытых платежей',
      desc: 'Прозрачное ценообразование — вы платите только за выбранный тариф',
    },
  ];

  return (
    <section id="contact" className="contact-section">
      {/* Фоновые декоративные иконки */}
      <div className="contact-bg-decor">
        <img loading="lazy" src="/images/icons/rocket.webp" alt="" className="contact-bg-icon contact-bg-icon-1" />
        <img loading="lazy" src="/images/icons/star.webp" alt="" className="contact-bg-icon contact-bg-icon-2" />
        <img loading="lazy" src="/images/icons/coins.webp" alt="" className="contact-bg-icon contact-bg-icon-3" />
        <img loading="lazy" src="/images/icons/lightning.webp" alt="" className="contact-bg-icon contact-bg-icon-4" />
        <img loading="lazy" src="/images/icons/crown.webp" alt="" className="contact-bg-icon contact-bg-icon-5" />
        <img loading="lazy" src="/images/icons/wallet.webp" alt="" className="contact-bg-icon contact-bg-icon-6" />
      </div>

      {/* Градиентные блики */}
      <div className="contact-glow contact-glow-1" />
      <div className="contact-glow contact-glow-2" />

      <div className="contact-container">
        <div className="form-block">
          {/* ЛЕВАЯ часть — форма */}
          <div className="form-card">
            <div className="form-card-content">
              <h3 className="form-card-title">Оставьте заявку</h3>
              <p className="form-card-subtitle">Перезвоним в течение 15 минут</p>

              <input
                className={`form-input ${focusedField === 'name' ? 'focused' : ''}`}
                type="text"
                name="name"
                placeholder="Ваше имя"
                value={formData.name}
                onChange={handleChange}
                onFocus={() => setFocusedField('name')}
                onBlur={() => setFocusedField(null)}
              />
              <input
                className={`form-input ${focusedField === 'phone' ? 'focused' : ''}`}
                type="tel"
                name="phone"
                placeholder="Телефон"
                value={formData.phone}
                onChange={handleChange}
                onFocus={() => setFocusedField('phone')}
                onBlur={() => setFocusedField(null)}
              />
              <div className="select-wrapper">
                <select
                  className={`form-select ${focusedField === 'marketplace' ? 'focused' : ''} ${formData.marketplace ? 'has-value' : ''}`}
                  name="marketplace"
                  aria-label="Выберите маркетплейс"
                  value={formData.marketplace}
                  onChange={handleChange}
                  onFocus={() => setFocusedField('marketplace')}
                  onBlur={() => setFocusedField(null)}
                >
                  <option value="" disabled>Выберите маркетплейс</option>
                  <option value="wildberries">Wildberries</option>
                  <option value="ozon">Ozon</option>
                  <option value="yandex">Яндекс Маркет</option>
                  <option value="multiple">Несколько площадок</option>
                  <option value="undecided">Ещё не определился</option>
                </select>
                <svg className="select-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>

              <button
                className="form-submit"
                onClick={handleSubmit}
                disabled={submitStatus === 'loading'}
                style={submitStatus === 'loading' ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
              >
                {submitStatus === 'loading' ? 'ОТПРАВКА...' : submitStatus === 'success' ? 'ОТПРАВЛЕНО!' : 'ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ'}
              </button>
              {submitError && (
                <p style={{ color: '#ef4444', fontSize: '13px', textAlign: 'center', margin: '8px 0 0 0' }}>
                  {submitError}
                </p>
              )}
              {submitStatus === 'success' && (
                <p style={{ color: '#22c55e', fontSize: '13px', textAlign: 'center', margin: '8px 0 0 0' }}>
                  Заявка отправлена! Свяжемся с вами в ближайшее время.
                </p>
              )}
              <p className="form-privacy">
                Нажимая кнопку, вы соглашаетесь с{' '}
                <a href="/privacy">политикой конфиденциальности</a>
              </p>
            </div>
          </div>

          {/* ПРАВАЯ часть — текст */}
          <div className="form-text">
            <span className="form-label">БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ</span>
            <h2 className="form-heading">
              Начните бомбить
              <br />
              на маркетплейсах
              <br />
              уже через 7 дней
            </h2>
            <p className="form-desc">
              Оставьте заявку и получите персональную стратегию продвижения вашего бизнеса
            </p>

            <div className="form-benefits">
              {benefits.map((benefit, index) => (
                <div className="benefit-item" key={index}>
                  <div className="benefit-icon">
                    <img loading="lazy" src={benefit.icon} alt="" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                  </div>
                  <div>
                    <div className="benefit-title">{benefit.title}</div>
                    <div className="benefit-desc">{benefit.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .contact-section {
            background: #0F0F1A;
            padding: 100px 0;
            position: relative;
            overflow: hidden;
          }

          /* Градиентные блики на фоне */
          .contact-glow {
            position: absolute;
            border-radius: 50%;
            pointer-events: none;
            z-index: 0;
          }

          .contact-glow-1 {
            width: 500px;
            height: 500px;
            top: -15%;
            left: -10%;
            background: radial-gradient(circle, rgba(255, 107, 53, 0.12) 0%, transparent 70%);
            filter: blur(60px);
          }

          .contact-glow-2 {
            width: 400px;
            height: 400px;
            bottom: -10%;
            right: -5%;
            background: radial-gradient(circle, rgba(255, 45, 124, 0.1) 0%, transparent 70%);
            filter: blur(60px);
          }

          /* Декоративные иконки на фоне */
          .contact-bg-decor {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            pointer-events: none;
            z-index: 0;
          }

          .contact-bg-icon {
            position: absolute;
            opacity: 0.06;
            filter: brightness(2) grayscale(0.3);
          }

          .contact-bg-icon-1 {
            width: 80px;
            height: 80px;
            top: 8%;
            left: 3%;
            transform: rotate(-12deg);
            animation: floatContact1 7s ease-in-out infinite;
          }

          .contact-bg-icon-2 {
            width: 60px;
            height: 60px;
            top: 15%;
            right: 8%;
            transform: rotate(15deg);
            animation: floatContact2 8s ease-in-out infinite;
          }

          .contact-bg-icon-3 {
            width: 70px;
            height: 70px;
            bottom: 20%;
            left: 5%;
            transform: rotate(8deg);
            animation: floatContact3 6s ease-in-out infinite;
          }

          .contact-bg-icon-4 {
            width: 55px;
            height: 55px;
            bottom: 12%;
            right: 4%;
            transform: rotate(-10deg);
            animation: floatContact4 9s ease-in-out infinite;
          }

          .contact-bg-icon-5 {
            width: 50px;
            height: 50px;
            top: 50%;
            left: 48%;
            transform: rotate(20deg);
            animation: floatContact2 10s ease-in-out infinite;
          }

          .contact-bg-icon-6 {
            width: 65px;
            height: 65px;
            top: 70%;
            right: 15%;
            transform: rotate(-5deg);
            animation: floatContact3 7s ease-in-out infinite;
          }

          @keyframes floatContact1 {
            0%, 100% { transform: rotate(-12deg) translateY(0); }
            50% { transform: rotate(-12deg) translateY(-10px); }
          }

          @keyframes floatContact2 {
            0%, 100% { transform: rotate(15deg) translateY(0); }
            50% { transform: rotate(15deg) translateY(-12px); }
          }

          @keyframes floatContact3 {
            0%, 100% { transform: rotate(8deg) translateY(0); }
            50% { transform: rotate(8deg) translateY(-8px); }
          }

          @keyframes floatContact4 {
            0%, 100% { transform: rotate(-10deg) translateY(0); }
            50% { transform: rotate(-10deg) translateY(-14px); }
          }

          .contact-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
            position: relative;
            z-index: 1;
          }

          .form-block {
            display: flex;
            align-items: center;
            gap: 60px;
          }

          /* Левая часть — форма */
          .form-card {
            width: 46%;
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 28px;
            padding: 48px 40px;
            position: relative;
            overflow: hidden;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
          }

          .form-card::before {
            content: '';
            position: absolute;
            top: -40%;
            right: -30%;
            width: 300px;
            height: 300px;
            background: radial-gradient(circle, rgba(255, 107, 53, 0.1) 0%, transparent 70%);
            border-radius: 50%;
            pointer-events: none;
            z-index: 0;
          }

          .form-card::after {
            content: '';
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 250px;
            height: 250px;
            background: radial-gradient(circle, rgba(255, 45, 124, 0.08) 0%, transparent 70%);
            border-radius: 50%;
            pointer-events: none;
            z-index: 0;
          }

          .form-card-content {
            position: relative;
            z-index: 1;
          }

          .form-card-title {
            font-family: 'Inter', sans-serif;
            font-size: 28px;
            font-weight: 800;
            color: #FFFFFF;
            margin: 0 0 8px 0;
          }

          .form-card-subtitle {
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.45);
            margin: 0 0 32px 0;
          }

          .form-input {
            width: 100%;
            padding: 18px 20px;
            background: rgba(255, 255, 255, 0.06);
            border: 1.5px solid rgba(255, 255, 255, 0.1);
            border-radius: 14px;
            color: #FFFFFF;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 400;
            outline: none;
            margin-bottom: 16px;
            transition: border-color 0.3s ease, background 0.3s ease;
            box-sizing: border-box;
          }

          .form-input::placeholder {
            color: rgba(255, 255, 255, 0.3);
          }

          .form-input:focus,
          .form-input.focused {
            border-color: rgba(255, 107, 53, 0.5);
            background: rgba(255, 255, 255, 0.08);
          }

          .select-wrapper {
            position: relative;
            margin-bottom: 24px;
          }

          .form-select {
            width: 100%;
            padding: 18px 44px 18px 20px;
            background: rgba(255, 255, 255, 0.06);
            border: 1.5px solid rgba(255, 255, 255, 0.1);
            border-radius: 14px;
            color: rgba(255, 255, 255, 0.3);
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-weight: 400;
            outline: none;
            cursor: pointer;
            appearance: none;
            transition: border-color 0.3s ease, background 0.3s ease;
            box-sizing: border-box;
          }

          .form-select.has-value {
            color: #FFFFFF;
          }

          .form-select option {
            background: #0F0F1A;
            color: #FFFFFF;
          }

          .form-select:focus,
          .form-select.focused {
            border-color: rgba(255, 107, 53, 0.5);
            background: rgba(255, 255, 255, 0.08);
          }

          .select-arrow {
            position: absolute;
            right: 18px;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
          }

          .form-submit {
            width: 100%;
            padding: 18px;
            background: linear-gradient(135deg, #FF6B35, #FF2D7C);
            border: none;
            border-radius: 50px;
            color: #FFFFFF;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            cursor: pointer;
            transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
          }

          .form-submit:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 30px rgba(255, 45, 124, 0.4);
            filter: brightness(1.08);
          }

          .form-privacy {
            font-family: 'Inter', sans-serif;
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.25);
            text-align: center;
            margin: 16px 0 0 0;
            line-height: 1.4;
          }

          .form-privacy a {
            color: rgba(255, 255, 255, 0.35);
            text-decoration: underline;
            transition: color 0.3s ease;
          }

          .form-privacy a:hover {
            color: rgba(255, 255, 255, 0.5);
          }

          /* Правая часть — текст */
          .form-text {
            width: 54%;
          }

          .form-label {
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.12em;
            background: linear-gradient(135deg, #FF6B35, #FF2D7C);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 20px;
            display: inline-block;
          }

          .form-heading {
            font-family: 'Inter', sans-serif;
            font-size: 42px;
            font-weight: 900;
            color: #FFFFFF;
            line-height: 1.1;
            letter-spacing: -0.02em;
            margin: 0 0 20px 0;
            text-transform: uppercase;
          }

          .form-desc {
            font-family: 'Inter', sans-serif;
            font-size: 17px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 1.6;
            margin: 0 0 40px 0;
          }

          .form-benefits {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .benefit-item {
            display: flex;
            align-items: flex-start;
            gap: 14px;
            margin-bottom: 24px;
            transition: transform 0.3s ease;
          }

          .benefit-item:hover {
            transform: translateX(4px);
          }

          .benefit-item:last-child {
            margin-bottom: 0;
          }

          .benefit-icon {
            width: 44px;
            height: 44px;
            min-width: 44px;
            border-radius: 14px;
            background: rgba(255, 107, 53, 0.1);
            border: 1px solid rgba(255, 107, 53, 0.15);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .benefit-title {
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-weight: 700;
            color: #FFFFFF;
            margin-bottom: 4px;
          }

          .benefit-desc {
            font-family: 'Inter', sans-serif;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.45);
            line-height: 1.5;
          }

          /* Адаптив */
          @media (max-width: 968px) {
            .form-block {
              flex-direction: column-reverse;
              gap: 40px;
            }

            .form-text,
            .form-card {
              width: 100%;
            }

            .form-heading {
              font-size: 34px;
            }

            .contact-bg-decor { display: none; }
            .contact-glow { display: none; }
          }

          @media (max-width: 768px) {
            .contact-section { padding: 60px 0; }
            .form-heading { font-size: 30px; }
            .form-desc { font-size: 15px; margin-bottom: 24px; }
            .form-card { padding: 36px 28px; border-radius: 20px; }
          }

          @media (max-width: 480px) {
            .contact-section {
              padding: 40px 0;
            }

            .form-heading {
              font-size: 24px;
            }

            .form-card {
              padding: 28px 20px;
            }

            .form-card-title {
              font-size: 22px;
            }

            .form-block {
              gap: 28px;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ContactFormSection;
